<header style="padding: 10px">
  <div class="header-wrapper">
    <button style="display:none" id="confirmTrigger" data-bs-toggle="modal" data-bs-target="#confirmationDialog">trigger</button>
    <div class="first-section">
      <h6 class="mb-0 table-title">Week Colors</h6>
      <div class="d-flex align-items-center justify-content-end">
        <div class="me-2">
         <ng-container *ngIf="currentTab !== 'schedule'">
          <ng-template [ngxPermissionsOnly]="['WeekColor:Delete']">
            <button class="btn ms-2 filter-btn" (click)="onBulkDelete()">
              <img style="width: 22px " src="../../../assets/Pricingscreen/delete.svg" />
            </button>
          </ng-template>
         </ng-container>
          </div>
        <div class="add-btns custom-left">
         
          <ng-template [ngxPermissionsOnly]="['WeekColor:Create']">
            <button
              class="btn createschedule"
              style="color: #ffffff"
              data-bs-toggle="offcanvas"
              data-bs-target="#addColoroffcanvas"
            >
              + Add Color
            </button>
          </ng-template>

          <ng-template [ngxPermissionsOnly]="['WeekColor:Create']">
            <button
              class="btn ms-2 createschedule"
              style="color: #ffffff"
              data-bs-toggle="offcanvas"
              data-bs-target="#createscheduleoffcanvas"
            >
              + Generate Schedule
            </button>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="tabs-container mt-3">
      <ul class="nav nav-pills" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="pills-colorsschedule-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-colorsschedule"
            type="button"
            role="tab"
            aria-controls="pills-colorsschedule"
            aria-selected="true"
            (click)="setTab('schedule')"
          >
            Colors Schedule
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="pills-activecolor-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-activecolor"
            type="button"
            role="tab"
            aria-controls="pills-activecolor"
            aria-selected="false"
            (click)="setTab('active')"
          >
            Active Colors
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="pills-inactivecolor-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-inactivecolor"
            type="button"
            role="tab"
            aria-controls="pills-inactivecolor"
            aria-selected="false"
            (click)="setTab('inactive')"
          >
            Inactive Colors
          </button>
        </li>
      </ul>
    </div>
  </div>
</header>

<section>
  <div class="tab-content pt-2" id="pills-tabContent">
    <!-- Colors Schedule Tab -->
    <div
      class="tab-pane fade show active"
      id="pills-colorsschedule"
      role="tabpanel"
      aria-labelledby="pills-colorsschedule-tab"
      tabindex="0"
    >
      <div class="company-container">
        <h3 class="ms-3 table-title">Color Schedule</h3>
        <div class="table-container">
          <table class="table category-table table-condensed">
            <thead class="main-head sticky-top">
              <tr>
                <th scope="col" style="align-items: center; text-transform: none; width: 25%">
                  <div class="form-check">
                    <label for="flexCheckDefault">Week Colors</label>
                  </div>
                </th>
                <th scope="col" style="width: 25%; text-align: center; text-transform: none">
                  Colors
                </th>
                <th scope="col" style="text-align: end; padding-right: 6rem; width: 15%; text-transform: none">
                  Week Number
                </th>
                <th scope="col" style="text-transform: none">Start Date</th>
                <th scope="col" style="text-transform: none">End Date</th>
                <th scope="col" style="text-transform: none">Detag</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let schedule of productioncycleSchedules">
                <td class="d-flex g-4" style="align-items: center">
                  <div class="form-check">
                    
                  </div>
                  <label for="" style="font-size: 14px; font-weight: 700">
                    {{ schedule.displayName }}
                  </label>
                </td>
                <td>
                  <div class="d-flex justify-content-center align-items-center">
                    <span
                      [style.backgroundColor]="schedule.color"
                      style="border-radius: 18px; height: 29px; border: 1px solid #d8d8d8; width: 98%"
                    ></span>
                  </div>
                </td>
                <td style="text-align: end; padding-right: 7rem; width: 15%">
                  {{ schedule.weekNumber }}
                </td>
                <td>{{ schedule.startDate | date : "MM/dd/yyyy" }}</td>
                <td>{{ schedule.endDate | date : "MM/dd/yyyy" }}</td>
                <td>{{ schedule.endDate | date : "MM/dd/yyyy" }}</td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="productioncycleSchedules?.length === 0" class="nodata" style="height:56vh; width:100%; display:flex; margin:auto; align-items:center; justify-content:center; border:none;">
            <p style="margin:auto; border:transparent !important; font-size:2rem; color:#a4a4a4; text-align:center;">No data available.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Active Colors Tab -->
    <div
      class="tab-pane fade pb-5"
      id="pills-activecolor"
      role="tabpanel"
      aria-labelledby="pills-activecolor-tab"
      tabindex="0"
    >
      <div class="company-container">
        <div class="table-container">
          <table class="table category-table table-condensed">
            <thead class="main-head sticky-top">
              <tr>
                <th scope="col" style="align-items: center; width: 25%; text-transform: none">
                  <div class="form-check">
                    <input
                      style="height: 20px; width: 20px; margin-right: 10px"
                      class="form-check-input me-3"
                      id="flexCheckDefault1"
                      type="checkbox"
                      [checked]="headerCheckboxSelected"
                      (change)="toggleAllCheckboxes()"
                    />
                    <label for="flexCheckDefault">Week Colors</label>
                  </div>
                </th>
                <th class="text-center" scope="col" style="width: 25%; text-transform: none">
                  Colors
                </th>
                <th scope="col" style="text-transform: none">Created On</th>
                <ng-template [ngxPermissionsOnly]="['WeekColor:Delete']" || [ngxPermissionsOnly]="['WeekColor:Update']">
                  <th scope="col" style="text-align: center">Actions</th>
                </ng-template>
                <th></th>
              </tr>
            </thead>

            <tbody
              cdkDropList
              (cdkDropListDropped)="MoveWeekColorRow($event)"
              cdkDragBoundary=".table-container"
            >
              <tr
                *ngFor="let weekColors of weekColorsList"
                [ngClass]="{ 'highlighted-row': weekColors.id === selectedRowIndex }"
                cdkDrag
              >
                <td class="d-flex g-4" style="align-items: center">
                  <div class="form-check">
                    <input
                      style="height: 20px; width: 20px; margin-right: 10px"
                      class="form-check-input mt-2 me-3"
                      type="checkbox"
                      value="weekcolor.productionCycleID"
                      id="flexCheckDefault1"
                      [checked]="headerCheckboxSelected"
                      [(ngModel)]="weekColors.isSelected"
                      (change)="handleCheckboxChange($event, weekColors)"
                    />
                  </div>
                  <label for="" style="font-size: 14px; font-weight: 700">
                    {{ weekColors.displayName }}
                  </label>
                </td>
                <td>
                  <div class="d-flex align-items-center justify-content-center">
                    <span
                      [style.backgroundColor]="weekColors.color"
                      style="border-radius: 18px; height: 29px; border: 1px solid #d8d8d8; width: 98%"
                    ></span>
                  </div>
                </td>
                <td>{{ weekColors.createdAt | date : "MM/dd/yyyy" }}</td>
                <td class="text-center">
                  <ng-template [ngxPermissionsOnly]="['WeekColor:Update']">
                    <img
                    
                       src="../../../assets/Pricingscreen/update.svg"
                      class="me-3"
                      style="cursor: pointer"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#addColoroffcanvas"
                      (click)="onEditWeekColor(weekColors.id)"
                    />
                  </ng-template>
                  <ng-template [ngxPermissionsOnly]="['WeekColor:Delete']">
                    <img
                    src="../../../assets/Pricingscreen/delete.svg"
                      style="cursor: pointer"
                      data-bs-toggle="modal"
                      data-bs-target="#confirmationDialog"
                      (click)="onDeleteWeekColor(weekColors.id)"
                    />
                  </ng-template>
                </td>
                <td class="text-center align-middle pe-3">
                  <img
                    class="drag-ic"
                    src="../../../../../assets/icons/ic_dragDrop.svg"
                    style="cursor: all-scroll"
                    cdkDragHandle
                    matTooltip="Drag to reorder"
                    matTooltipPosition="above"
                    matTooltipClass="raised-tooltip"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="weekColorsList?.length === 0" class="nodata" style="height:56vh; width:100%; display:flex; margin:auto; align-items:center; justify-content:center; border:none;">
            <p style="margin:auto; border:transparent !important; font-size:2rem; color:#a4a4a4; text-align:center;">No data available.</p>
          </div>
        </div>


      </div>
    </div>

    <!-- Inactive Colors Tab -->
    <div
      class="tab-pane fade pb-5"
      id="pills-inactivecolor"
      role="tabpanel"
      aria-labelledby="pills-inactivecolor-tab"
      tabindex="0"
    >
      <div class="company-container">
        <div class="table-container">
          <table class="table category-table table-condensed">
            <thead class="main-head sticky-top">
              <tr>
                <th scope="col" style="align-items: center; width: 25%; text-transform: none">
                  <div class="form-check">
                    <input
                      style="height: 20px; width: 20px; margin-right: 10px"
                      class="form-check-input me-3"
                      type="checkbox"
                      [checked]="headerCheckboxSelected"
                      (change)="toggleAllCheckboxes()"
                    />
                    <label>Week Colors</label>
                  </div>
                </th>
                <th class="text-center" scope="col" style="width: 25%; text-transform: none">
                  Colors
                </th>
                <th scope="col" style="text-transform: none">Created On</th>
                <th scope="col" style="text-align: center">Actions</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="let weekColors of weekColorsList"
                [ngClass]="{ 'highlighted-row': weekColors.id === selectedRowIndex }"
              >
                <td class="d-flex g-4" style="align-items: center">
                  <div class="form-check">
                    <input
                      style="height: 20px; width: 20px; margin-right: 10px"
                      class="form-check-input mt-2 me-3"
                      type="checkbox"
                      [checked]="headerCheckboxSelected"
                      [(ngModel)]="weekColors.isSelected"
                      (change)="handleCheckboxChange($event, weekColors)"
                    />
                  </div>
                  <label style="font-size: 14px; font-weight: 700">
                    {{ weekColors.displayName }}
                  </label>
                </td>
                <td>
                  <div class="d-flex align-items-center justify-content-center">
                    <span
                      [style.backgroundColor]="weekColors.color"
                      style="border-radius: 18px; height: 29px; border: 1px solid #d8d8d8; width: 98%"
                    ></span>
                  </div>
                </td>
                <td>{{ weekColors.createdAt | date : "MM/dd/yyyy" }}</td>
                <td class="text-center">
                  <ng-template [ngxPermissionsOnly]="['WeekColor:Update']">
                    <img
                    
                       src="../../../assets/Pricingscreen/update.svg"
                      class="me-3"
                      style="cursor: pointer"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#addColoroffcanvas"
                      (click)="onEditWeekColor(weekColors.id)"
                    />
                  </ng-template>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="weekColorsList?.length === 0" class="nodata" style="height:56vh; width:100%; display:flex; margin:auto; align-items:center; justify-content:center; border:none;">
            <p style="margin:auto; border:transparent !important; font-size:2rem; color:#a4a4a4; text-align:center;">No data available.</p>
          </div>
        </div>

        <!-- <div class="d-flex justify-content-end mt-3">
          <button
            class="btn"
            style="background-color: rgba(23, 95, 145, 1); color: white"
            (click)="onMarkAsActive()"
          >
            Mark as Active
          </button>
        </div> -->
      </div>
    </div>
  </div>
</section>

<!-- Include the child component for managing add/update/delete operations -->
<app-add-week-colors
  (weekColorSaved)="onWeekColorSaved()"
  (weekColorDeleted)="onWeekColorDeleted()"
  (modalCancelled)="uncheckSelectedCheckboxes()"
  (scheduleSaved)="onScheduleSaved()"
  [weekColorList]="activeWeekColorsList"
></app-add-week-colors>